import Bloc from './Bloc.js';
import Types from './Types.js';

export default class CompareEntities extends Bloc {

	constructor (src, ctx) {

		super("cmpentities", src, ctx);
		this.f = (src, ins, props) => {
			if (!ins[0] || !ins[1])
				return [false];
			if (typeof ins[0] === "string" || (ins[0].type && ins[0].no !== undefined))
				ins[0] = src.master.find(ins[0]);
			if (typeof ins[1] === "string" || (ins[1].type && ins[1].no !== undefined))
				ins[1] = src.master.find(ins[1]);
			if (!ins[0] || !ins[1])
				return [false];
			if (!ins[0].id || !ins[1].id)
				return [ins[0] === ins[1], false];
			return [ins[0].id.type === ins[1].id.type && ins[0].id.no === ins[1].id.no, (ins[0].id === "player") !== (ins[1].id === "player")];
		}
		this.types = [Types.entity, Types.entity];
	}
}
